import MasterCrudPage from "../../components/MasterCrudPage";
import { devDarshanApi } from "../../api/masterApi";

export default function DevDarshan() {
  return (
    <MasterCrudPage
      title="Dev Darshan"
      description="Manage Dev Darshan entries with description, URL and active status."
      idKey="dev_darshan_id"
      api={devDarshanApi}
      listLabel="Dev Darshan entries"
      useJson
      fields={[
        {
          name: "dev_darshan",
          label: "Dev Darshan",
          type: "text",
          required: true,
          placeholder: "Dev Darshan title",
        },
        {
          name: "url",
          label: "URL",
          type: "text",
          placeholder: "https://...",
        },
        {
          name: "short_description",
          label: "Short Description",
          type: "textarea",
          placeholder: "Short description",
        },
        {
          name: "is_active",
          label: "Is Active",
          type: "checkbox",
          defaultValue: true,
          yesNo: true,
        },
      ]}
      columns={[
        { key: "dev_darshan_id", label: "Dev Darshan" },
        { key: "dev_darshan", label: "Dev Darshan" },
        { key: "short_description", label: "Short Description" },
        { key: "url", label: "URL" },
        { key: "is_active", label: "Is Active", type: "status" },
      ]}
    />
  );
}
